<template>
  <div>
    <h1>Incidències de les teves subcategories</h1>
    <AddTicket/>
    <ManagerTicketsTable :table_rows="this.groups_tickets"
    :priorities="priorities" :states="states" v-if="this.groups_tickets" :other_filters="['Suprimir duplicades o descartades']"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ManagerTicketsTable from '@/components/ManagerTicketsTable'
import AddTicket from '@/components/AddTicket'

export default {
  components: {
    ManagerTicketsTable,
    AddTicket
  },
  computed: {
    ...mapGetters({
      groups_tickets: 'managerGroupsTickets'
    }),
    states () {
      return this.$store.state.states.map(function (obj) {
        return obj.displayname
      })
    },
    priorities () {
      return this.$store.state.priorities.map(function (obj) {
        return obj.descripcio
      })
    }
  },
  created () {
    this.$store.dispatch('fetchManagerGroupsTickets')
    this.$store.dispatch('fetchStates')
    this.$store.dispatch('fetchPrioritats')
  }
}
</script>

<style module>
</style>
